export default __webpack_public_path__ + "static/381-3b4d25060826e1215c320edfafc5f04a.gif";